export default "__VITE_ASSET__BtSRnN5i__"